import React, { useEffect, useRef } from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import A1GA from '../../helpers/A1GA';

/*
 * !!! IMPORTANT !!!
 * This is a video player component to ***CLIENT SIDE*** only. The config and props in this component
 * will work only on client side front-end. It is built on react-player package.
 * See GitHub documentation for more information: https://github.com/CookPete/react-player
 * There is another similar, almost identical component video player to work on webviews.
 * To deal with the player on webviews, please go to: /src/components/mobileApplication/common/AppWebviewVideoPlayer
 *
 * Note: We do now send the total progress reached when leaving the page or when reaching the end of the video.
 * This is DIFFERENT from the way it was before where we have been counting the seconds the player was playing.
 * Ex. The user was watching the first 10 seconds and then the last 10 seconds of a 40 seconds video.
 * Before we logged this as 50% watched.
 * Now we log it as 100% watched, as the player reached the end.
 *
 * On the other hand, if the user would watch the first 10 seconds twice of a 40 seconds video:
 * Before we logged it as 50% watched.
 * Now we log it as 25%.
 *
 * Note: we do not reset the progress when the user returns the video. Always the highest reached progress will be logged.
 * Ex. User watches a video until 50% and goes than back to 25% and watches until 30%. We now log it as 50%.
 * (Before this would have been logged as 55%)
 *
 * Note: Both ways are not really good. But it should give us an estimate about the video watch rate.
 * Note2: I was not able to replicate the same way of logging as before with hooks, thats the reason for the change in behavior :/
 */
const VideoPlayer = ({
    fileName,
    className = 'react-player',
    videoQuality = '480p',
    controls = true,
    where = '',
}) => {
    const progressPlayed = useRef(0);
    const videoPath = `https://a1media.antena1.com.br/video/${videoQuality}/${fileName}`;

    const sendMetricsGA = () => {
        // only log if the video has been started
        if (progressPlayed.current > 0) {
            A1GA.event({
                category: 'VideoPlayer',
                action: `videoEnded_${where}`,
                label: fileName,
                value: progressPlayed.current * 100, // % percent of video played
            });
        }
    };

    const updateProgress = (progress) => {
        // only update the played progress if it increased
        if (progress.played > progressPlayed.current) {
            // setProgressPlayed(progress.played);
            progressPlayed.current = progress.played;
        }
    };

    // call the sendMetricsGA function on willUnmount
    useEffect(() => () => {
        sendMetricsGA();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="react-player-wrapper">
            <ReactPlayer
                className={className}
                url={videoPath}
                controls={controls}
                height="100%"
                width="100%"
                onEnded={sendMetricsGA}
                onProgress={(_progress) => updateProgress(_progress)}
            />
        </div>
    );
};

VideoPlayer.propTypes = exact({
    fileName: PropTypes.string,
    videoQuality: PropTypes.string,
    where: PropTypes.string,
    className: PropTypes.string,
    controls: PropTypes.bool,
});

export default VideoPlayer;
